module.exports = {
  'en': {
    'HRES62EC1': {
      '5': 'Start Req. Date',
      '7': 'To',
      '10': 'Req. Date',
      '20': 'Seq.',
      '30': 'Leave Code',
      '40': 'Leave Period',
      '50': 'Status',
      '60': 'Remarks',
      '70': 'Last Approver',
      '80': 'Next Step Approval',
      '90': 'Leave req. No.',
      '99': 'Request for Record Leave Application'
    },
    'HRES62EC2': {
      '10': 'Leave Application',
      '15': 'Leave Available',
      '20': 'Date',
      '25': 'Seq. No.',
      '30': 'Leave Code',
      '40': 'Detail of Leave',
      '50': 'From Date',
      '60': 'To Date',
      '70': 'From Time',
      '80': 'To Time',
      '90': 'See More Details.',
      '100': 'Leave Condition',
      '110': 'Leave Available',
      '120': 'Atach File',
      '130': 'Approve By Next Step',
      '140': 'Update By',
      '150': 'Actual Time in-out',
      '160': 'Shift Code',
      '170': 'Working Time',
      '180': 'Leave Date',
      '200': 'Full Day',
      '210': '1st half',
      '220': '2nd half',
      '230': 'Hours.',
      '250': 'Type of Leave',
      '260': 'Leave Limitation',
      '261': 'Per Case',
      '262': 'Per Year',
      '270': 'Day',
      '280': 'Hour',
      '290': 'Min',
      '300': 'Entitlement',
      '310': 'Actual Leave',
      '320': 'Balance',
      '330': 'Total Request',
      '340': 'More information.'
    },
    'HRES62EC3': {
      '10': 'Leave Condition',
      '20': 'Leave Code',
      '30': 'Leave Count Method',
      '40': 'Eligibility Condition'
    },
    'HRES62EC4': {
      '10': 'Leave Details',
      '20': 'Type of Leave',
      '30': 'Leave Limitation',
      '40': 'Per Case',
      '50': 'Per Year',
      '60': 'Day',
      '70': 'Hour',
      '80': 'Min',
      '90': 'Entitlement',
      '100': 'Actual Leave',
      '110': 'Balance',
      '120': 'Total Request',
      '130': 'Total Leave times',
      '140': 'Times',
      '150': 'Total Leave For This Application',
      '160': 'With Pay',
      '170': 'Without Pay'
    },
    'HRES62EC5': {
      '10': 'Leave Details',
      '20': 'Type of Leave',
      '30': 'Leave Limitation',
      '40': 'Per Case',
      '50': 'Per Year',
      '60': 'Day',
      '70': 'Hour',
      '80': 'Min',
      '90': 'Entitlement',
      '100': 'Actual Leave',
      '110': 'Balance',
      '120': 'Total Request'
    }
  },
  'th': {
    'HRES62EC1': {
      '5': 'วันที่ขอตั้งแต่',
      '7': 'ถึง',
      '10': 'วันที่ขอ',
      '20': 'ลำดับที่',
      '30': 'รหัสการลา',
      '40': 'ช่วงวันที่ขอลา',
      '50': 'สถานะ',
      '60': 'หมายเหตุ',
      '70': 'ผู้อนุมัติล่าสุด',
      '80': 'ผู้อนุมัติลำดับถัดไป',
      '90': 'เลขที่ใบลา',
      '99': 'คำร้องขอลาหยุดงาน'
    },
    'HRES62EC2': {
      '10': 'บันทึกใบลาหยุดงาน',
      '15': 'สิทธิการลาคงเหลือ',
      '20': 'วันที่ขอ',
      '25': 'ลำดับที่',
      '30': 'การลาหยุดงาน',
      '40': 'รายละเอียดการลา',
      '50': 'ตั้งแต่วันที่',
      '60': 'ถึงวันที่',
      '70': 'ตั้งแต่เวลา',
      '80': 'ถึงเวลา',
      '90': 'รายละเอียดเพิ่มเติม',
      '100': 'รายละเอียดการลา',
      '110': 'สิทธการลาคงเหลือ',
      '120': 'แนบไฟล์',
      '130': 'อนุมัติโดยข้ามขั้นตอน',
      '140': 'ผู้บันทึก',
      '150': 'รายละเอียดเวลาปฏิบัติงาน',
      '160': 'รหัสกะ',
      '170': 'เวลาปฎิบัติงาน',
      '180': 'วันที่ลา',
      '200': 'เต็มวัน',
      '210': 'ครึ่งแรก',
      '220': 'ครึ่งหลัง',
      '230': 'กำหนดเอง',
      '250': 'ประเภทการลา',
      '260': 'การนับสิทธิ์การลา',
      '261': 'ต่อครั้ง',
      '262': 'ต่อปี',
      '270': 'วัน',
      '280': 'ชม.',
      '290': 'นาที',
      '300': 'จำนวนวันลาที่มีสิทธิ์',
      '310': 'จำนวนวันลาสะสม',
      '320': 'คงเหลือ',
      '330': 'จำนวนวันที่ขอลาสะสม',
      '340': 'ข้อมูลเพิ่มเติม'
    },
    'HRES62EC3': {
      '10': 'รายละเอียดการลา',
      '20': 'รหัสการลา',
      '30': 'วิธีนับวันลา',
      '40': 'เงื่อนไขผู้มีสิทธิลา'
    },
    'HRES62EC4': {
      '10': 'รายละเอียดการลาหยุด',
      '20': 'ประเภทการลา',
      '30': 'การนับสิทธิ์การลา',
      '40': 'ต่อครั้ง',
      '50': 'ต่อปี',
      '60': 'วัน',
      '70': 'ชม.',
      '80': 'นาที',
      '90': 'จำนวนวันลาที่มีสิทธิ์',
      '100': 'จำนวนวันลาสะสม',
      '110': 'คงเหลือ',
      '120': 'จำนวนวันที่ขอลาสะสม',
      '130': 'จำนวนครั้งที่ลาสะสม',
      '140': 'ครั้ง',
      '150': 'จำนวนวันลาครั้งนี้',
      '160': 'ได้รับเงินเดือน',
      '170': 'ไม่ได้รับเงินเดือน'
    },
    'HRES62EC5': {
      '10': 'สิทธิการลาหยุด',
      '20': 'ประเภทการลา',
      '30': 'การนับสิทธิ์การลา',
      '40': 'ต่อครั้ง',
      '50': 'ต่อปี',
      '60': 'วัน',
      '70': 'ชม.',
      '80': 'นาที',
      '90': 'จำนวนวันลาที่มีสิทธิ์',
      '100': 'จำนวนวันลาสะสม',
      '110': 'คงเหลือ',
      '120': 'จำนวนวันที่ขอลาสะสม'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hres62e.js